export const checkIneligibleYear = yearParam => {
  const yearEligible = new Date().getFullYear() - 24
  const monthForYearEligible = new Date().getMonth() < 11
  const isIneligibleYear = yearParam == new Date().getFullYear() ? monthForYearEligible : yearParam < yearEligible
  return isIneligibleYear
}

export const QUESTION_TWO_KEYS = 'qp/79'